<template>
	<div class="page-container">
		<md-dialog-alert
		:md-active.sync="alert"
		:md-content="msg"
		md-confirm-text="Ok" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Jogar Cartas!
				</span>
			</md-app-toolbar>
			<md-app-content style="padding: 5px;padding-top: 0px;" class="p-2">

				<div class="wrapper">
					<div class="titan-card" v-for="i in 500">
						<div class="titan-card-content">
							<div class="front">
								Front
							</div>
							<div class="back">
								Back!
							</div>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'

	export default {
		name: 'TitanCards',
		components: {
		},
		props: [],
		data () {
			return {
			}
		},
		created() {
		},
		methods: {
		},
		mounted() {


		}
	}
</script>

<style lang="scss" scoped>
	@import "~vue-material/dist/theme/engine"; // Import the theme engine

	@include md-register-theme("default", (
		primary: #000000, // The primary color of your brand
		accent: #CB1323 // The secondary color of your brand
		));

	@import "~vue-material/dist/theme/all"; // Apply the theme

</style>


// WEBPACK FOOTER //
// src/components/TitanCards.vue